import { queryClient } from "./client";

export const AUTH_KEY = "auth" as const;

export const PROFILE_KEY = "profile" as const;
export const COMPANY_KEY = "company" as const;
export const ATS_KEY = "ats" as const;
export const JOB_OFFER_KEY = "job-offer" as const;
export const JOB_APPLICATION_KEY = "job-application" as const;
export const FREELANCER_KEY = "freelancer" as const;
export const PROPOSAL_KEY = "proposal" as const;
export const FREELANCER_INVITATIONS_KEY = "freelancer-invitations" as const;
export const FREELANCER_INVITATION_LINK_KEY =
  "freelancer-invitation-link" as const;
export const FREELANCER_RECOMMENDATIONS_KEY =
  "freelancer-recommendations" as const;

// Lives here and not in `freelance/dashboard/api` because the availability mutation in
// `freelance/profile/api` must invalidate it (D18) — the notice that sent the user to
// the modal has to disappear on save — and `profile/api` must not import from the
// dashboard slice to do it.
export const FREELANCE_DASHBOARD_KEY = [FREELANCER_KEY, "dashboard"] as const;

export const BILLING_KEY = "billing" as const;
export const BILLING_SUBSCRIPTION_KEY = "billing-subscription" as const;
export const BILLING_STATUS_KEY = "billing-status" as const;
export const BILLING_PLANS_KEY = "billing-plans" as const;
export const BILLING_INVOICES_KEY = "billing-invoices" as const;
export const BILLING_USAGE_KEY = "billing-usage" as const;
export const BILLING_CAMPAIGN_KEY = "billing-campaign" as const;

export const TALENT_POOL_KEY = "talent-pool" as const;

// I chip dell'onboarding dipendono solo dalla categoria, non dal profilo: fuori
// dal prefisso `PROFILE_KEY`, così le invalidazioni del profilo non li
// richiedono al catalogo (P-DL15).
export const ONBOARDING_SKILL_CHIPS_KEY = "onboarding-skill-chips" as const;

// Fuori dall'unione `QueryKey`: le etichette della tassonomia non si invalidano mai.
export const TAXONOMY_KEY = "taxonomy" as const;

export type QueryKey =
  | typeof AUTH_KEY
  | typeof PROFILE_KEY
  | typeof COMPANY_KEY
  | typeof ATS_KEY
  | typeof JOB_OFFER_KEY
  | typeof JOB_APPLICATION_KEY
  | typeof FREELANCER_KEY
  | typeof PROPOSAL_KEY
  | typeof FREELANCER_INVITATIONS_KEY
  | typeof FREELANCER_INVITATION_LINK_KEY
  | typeof BILLING_KEY
  | typeof TALENT_POOL_KEY;

export const invalidateGlobalQuerys = (queryKeys: QueryKey[]) => {
  for (const queryKey of queryKeys) {
    queryClient.invalidateQueries({ queryKey: [queryKey] });
  }
};

export const resetGlobalQuerys = (queryKeys: QueryKey[]) => {
  for (const queryKey of queryKeys) {
    queryClient.removeQueries({ queryKey: [queryKey] });
  }
};

export const clearGlobalQuerys = () => {
  queryClient.clear();
};
